var map = {
	"./de.json": [
		1909,
		42
	],
	"./en-AU.json": [
		1910,
		43
	],
	"./en-GB.json": [
		1911,
		44
	],
	"./en-HK.json": [
		1912,
		45
	],
	"./en-SG.json": [
		1913,
		46
	],
	"./en-us.json": [
		1914,
		47
	],
	"./fr.json": [
		1915,
		48
	],
	"./global.json": [
		1916,
		49
	],
	"./it.json": [
		1917,
		50
	],
	"./zh-Hant.json": [
		1918,
		51
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 1906;
module.exports = webpackAsyncContext;